<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="small">
        <div class="content-name">
          <h2 class="dp-ib">{{ title }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-search" @click="goOpen">{{ this.$i18n.messages[this.$store.state.locale].search }}</el-button>
          </el-form-item>
        </div>
      </el-form>
      <!-- 검색조건 영역 -->
      <div class="search-form">
        <el-form size="mini" label-width="80px">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="12">
              <el-form-item label="정산년월" label-width="120px">
                <el-col :span="10">
                  <el-select v-model="form.years">
                    <el-option
                        v-for="item in combos['years']"
                        :key="item.value"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="10">
                  <el-select v-model="form.months">
                    <el-option
                        v-for="item in combos['months']"
                        :key="item.value"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 테이블 -->
      <div class="talbe-contain">
        <div class="table-sub-contain"  style="width: 100%;">
          <div class="table-area">
            <div class="table-b">
              <!-- <dhx-grid ref="grid2" v-model="subData" :config="config_child" /> -->
              <ag-grid-vue
                  ref="gridSub"
                  style="width: 100%; height: 78vh; min-height: 25px;"
                  class="ag-theme-alpine"
                  :enableRangeSelection="true"
                  :columnDefs="columnDefsSub"
                  :defaultColDef="defaultColDefSub"
                  :frameworkComponents="frameworkComponents"
                  :rowData="subData"
                  :gridOptions="gridOptionsSub"
                  :suppressRowClickSelection="false"
                  :statusBar="statusBar"
                  @grid-ready="onReadyMain"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import _ from "lodash";

import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer'
import common from '@/mixin/common';

/**
 * Url JOIN
 */
function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  mixins: [common],
  name: "product",
  components: {},
  data() {
    return {
      title: "",
      deleteList: [],
      parentNm: "",
      form: {
        startDt: this.$moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
        endDt: this.$moment().format('YYYY-MM-DD'),
        groupKey: "",
        groupNm: "",
        groupUid: "",
        parentId: "",
        topKey: "",
        groupIdx: "",
        description: "",
        groupValue1: "",
        groupValue2: "",
        groupValue3: "",
        groupValue4: "",
        groupValue5: "",
        modelCd : "",
        maker : "",
        modelGroup : "",
        standardModelNm : "",
        modelNm : "",
        years : this.$moment().format('YYYY'),
        months : this.$moment().format('MM'),
      },
      defForm: {
        groupKey: "",
        groupNm: "",
        groupUid: "",
        parentId: "",
        topKey: "",
        groupIdx: "",
        description: "",
        groupValue1: "",
        groupValue2: "",
        groupValue3: "",
        groupValue4: "",
        groupValue5: "",
      },
      data: [],
      subData: [],
      gridOptions: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
      },
      gridOptionsSub: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
        getRowStyle: (params) =>
            params.node.lastChild
                ? { backgroundColor: 'yellow', 'font-weight': 'bold' }
                : null
      },
      defaultColDef: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
      },
      defaultColDefSub: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
        //cellStyle : {'justify-content': 'center','align-items': 'center', 'display': 'flex','height': '100%'}
      },
      combos: {
        'years' : [],
        'months' : [],
      },
      groupDetail: [],
      gridApi: null,
      columnApi: null,
      columnDefs: [],
      gridApiSub: null,
      columnApiSub: null,
      columnDefsSub: [],
      frameworkComponents: null,
      selectId : "",
      makerCombo : [],
      productCombo1 : [],
      productCombo2 : [],
      componentForm : [],
    };
  },
  methods: {
    //메인그리드 Ready
    onReadyMain(params) {
      //메인그리드 api 정의
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.gridApi.sizeColumnsToFit();
      this.init();
      this.goOpen();
    },
    //서브그리드 Ready
    onReadySub(params) {
      //서브그리드 api 정의
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;


      this.gridApiSub.sizeColumnsToFit();
    },
    //그리드컬럼 정의
    createColumnDefs() {
      const vm = this

      this.columnDefsSub = [
        {headerName:'센터명', field:'asAgentNm', width:100, editable:false},
        {
          headerName: '컴퓨터', children: [
            {headerName: '데스크탑', children: [
                {headerName: '수량', field: 'modelGroupCdQty', width: 50, editable: false},
                {headerName: '금액', field: 'modelGroupCdAmt', width: 50, editable: false,
                  valueFormatter: (params) => {
                    return vm.getNumberFormat(params.value);
                  }
                },
              ]},
            {headerName: '노트북', field: '', width: 50, editable: false, children: [
                {headerName: '수량', field: 'modelGroupCnQty', width: 50, editable: false},
                {headerName: '금액', field: 'modelGroupCnAmt', width: 50, editable: false,
                  valueFormatter: (params) => {
                    return vm.getNumberFormat(params.value);
                  }
                },
              ]},
            {headerName: '기타', field: '', width: 50, editable: false, children: [
                {headerName: '수량', field: 'modelGroupCEtcQty', width: 50, editable: false},
                {headerName: '금액', field: 'modelGroupCEtcAmt', width: 50, editable: false,
                  valueFormatter: (params) => {
                    return vm.getNumberFormat(params.value);
                  }
                },
              ]},
          ], width: 400, editable: false,
        },
        {
          headerName: '모니터', children: [
            {headerName: 'LCD', children: [
                {headerName: '수량', field: 'modelGroupMlQty', width: 50, editable: false},
                {headerName: '금액', field: 'modelGroupMlAmt', width: 50, editable: false,
                  valueFormatter: (params) => {
                    return vm.getNumberFormat(params.value);
                  }
                },
              ]},
            {headerName: 'CDT', field: '', width: 50, editable: false, children: [
                {headerName: '수량', field: 'modelGroupMcQty', width: 50, editable: false},
                {headerName: '금액', field: 'modelGroupMcAmt', width: 50, editable: false,
                  valueFormatter: (params) => {
                    return vm.getNumberFormat(params.value);
                  }
                },
              ]},
            {headerName: '기타', field: '', width: 50, editable: false, children: [
                {headerName: '수량', field: 'modelGroupMEtcQty', width: 50, editable: false},
                {headerName: '금액', field: 'modelGroupMEtcAmt', width: 50, editable: false,
                  valueFormatter: (params) => {
                    return vm.getNumberFormat(params.value);
                  }
                },
              ]},
          ], width: 400, editable: false,
        },
        {
          headerName: 'TV', children: [
            {headerName: '수량', field: 'modelGroupTQty', width: 50, editable: false},
            {headerName: '금액', field: 'modelGroupTAmt', width: 50, editable: false,
              valueFormatter: (params) => {
                return vm.getNumberFormat(params.value);
              }
            },
          ], width: 400, editable: false,
        },
        {
          headerName: '냉장고', children: [
            {headerName: '수량', field: 'modelGroupFQty', width: 50, editable: false},
            {headerName: '금액', field: 'modelGroupFAmt', width: 50, editable: false,
              valueFormatter: (params) => {
                return vm.getNumberFormat(params.value);
              }
            },
          ], width: 400, editable: false,
        },
        {
          headerName: '에어컨', children: [
            {headerName: '수량', field: 'modelGroupAQty', width: 50, editable: false},
            {headerName: '금액', field: 'modelGroupAAmt', width: 50, editable: false,
              valueFormatter: (params) => {
                return vm.getNumberFormat(params.value);
              }
            },
          ], width: 400, editable: false,
        },
        {
          headerName: '세탁기', children: [
            {headerName: '수량', field: 'modelGroupWQty', width: 50, editable: false},
            {headerName: '금액', field: 'modelGroupWAmt', width: 50, editable: false,
              valueFormatter: (params) => {
                return vm.getNumberFormat(params.value);
              }
            },
          ], width: 400, editable: false,
        },
        {
          headerName: '공기청정기', children: [
            {headerName: '수량', field: 'modelGroupAirQty', width: 50, editable: false},
            {headerName: '금액', field: 'modelGroupAirAmt', width: 50, editable: false,
              valueFormatter: (params) => {
                return vm.getNumberFormat(params.value);
              }
            },
          ], width: 400, editable: false,
        },
        {
          headerName: '의류건조기', children: [
            {headerName: '수량', field: 'modelGroupYQty', width: 50, editable: false},
            {headerName: '금액', field: 'modelGroupYAmt', width: 50, editable: false,
              valueFormatter: (params) => {
                return vm.getNumberFormat(params.value);
              }
            },
          ], width: 400, editable: false,
        },
        {
          headerName: '사운드바', children: [
            {headerName: '수량', field: 'modelGroupSoundBarQty', width: 50, editable: false},
            {headerName: '금액', field: 'modelGroupSoundBarAmt', width: 50, editable: false,
              valueFormatter: (params) => {
                return vm.getNumberFormat(params.value);
              }
            },
          ], width: 400, editable: false,
        },
        {
          headerName: '전자레인지', children: [
            {headerName: '수량', field: 'modelGroupMwQty', width: 50, editable: false},
            {headerName: '금액', field: 'modelGroupMwAmt', width: 50, editable: false,
              valueFormatter: (params) => {
                return vm.getNumberFormat(params.value);
              }
            },
          ], width: 400, editable: false,
        },
        {
          headerName: '청소기', children: [
            {headerName: '수량', field: 'modelGroupCleanerQty', width: 50, editable: false},
            {headerName: '금액', field: 'modelGroupCleanerAmt', width: 50, editable: false,
              valueFormatter: (params) => {
                return vm.getNumberFormat(params.value);
              }
            },
          ], width: 400, editable: false,
        },
        {
          headerName: '펫드라이어룸', children: [
            {headerName: '수량', field: 'modelGroupPetQty', width: 50, editable: false},
            {headerName: '금액', field: 'modelGroupPetAmt', width: 50, editable: false,
              valueFormatter: (params) => {
                return vm.getNumberFormat(params.value);
              }
            },
          ], width: 400, editable: false,
        },
        {
          headerName: '합계', children: [
            {headerName: '수량', field: 'modelGroupQty', width: 50, editable: false},
            {headerName: '금액', field: 'modelGroupAmt', width: 50, editable: false,
              valueFormatter: (params) => {
                return vm.getNumberFormat(params.value);
              }
            },
            {headerName: '대당 비용', field: 'modelGroupAmt', width: 50, editable: false,
              valueFormatter: (params) => {
                return vm.getltlAccount(params);
              }
            },
          ], width: 400, editable: false,
        },
      ];

    },
    goOpen() {

      this.$store.commit('loading')
      this.$http
          .post("/api/reportMng/agent/install", {
            companyId: this.$store.state.loginInfo.compCd,
            squareYymm: this.form.years+this.form.months,
            sortType : '',
            page : 1,
            totalPage : 9999,
            totalCount : 9999,
            curPage : 0,
            processTime : ""
          })
          .then(response => {
            this.subData = response.data.serviceList;
            response.data.serviceResult[0].asAgentNm = '합계';
            this.subData.push(response.data.serviceResult[0]);
          }).finally(() => {
        this.$store.commit('finish')
        this.autoSizeAll(this.columnApi);
      });

    },
    autoSizeAll(columnApi) {
      const allColumnIds = [];
      columnApi.columnController.gridColumns.forEach((column) => {
        allColumnIds.push(column.getId());
      });
      columnApi.columnController.autoSizeColumns(allColumnIds, false);
    },
    getNumberFormat(val) {
      if(val){

        if(typeof val === "string"){
          val = val.replace(/[^0-9]/g, "")
        }

        return Math.floor(val).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
    },
    getltlAccount(params){
      const Qty = params.data.modelGroupQty;
      const Amt = params.data.modelGroupAmt;
      let val = params.data.modelGroupAmt;
      if(params.data.length !=0 && Amt !=0)val = Math.round(Amt/Qty);

      return Math.floor(val).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/reportMng/agent/init`,{
      })
      .then(response => {
        this.combos['years'] = response.data.years;
        this.combos['months'] = response.data.months;
      }).finally(() => {
        //this.goOpen();
        this.$store.commit('finish');
      });
    },

  },
  beforeMount() {

    this.createColumnDefs(); //그리드 컬럼정의 함수 호출

    this.frameworkComponents = {//그르드에서 사용할 외부 comp 등록
      checkboxRenderer: CheckboxCellRenderer,
    };

  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
    this.title = this.$route.name;
  },
};

</script>


<style scoped>
.gridbox {
  height: 200px !important;
}
.gridbox .objbox {
  height: 350px !important;
}

.desc-content:after {
  clear: both;
  content: "";
  display: block;
}
.btn-wrap {
  margin-bottom: 20px;
}
.desc-content {
  border: 2px solid #9db6c9;
  background: #f9fafc;
  margin: 0 0 20px 0;
  border-radius: 4px;
  padding: 15px 2%;
  clear: both;
}
.desc-content .item {
  float: left;
}
.desc-content .item .desc-item {
  position: relative;
  padding-left: 82px;
  margin-bottom: 8px;
}
.desc-content .item .desc-item:last-child {
  margin-bottom: 0;
  height: 25px;
}
.desc-content .item .desc-item .tit {
  position: absolute;
  left: 0;
}
.desc-content .item .desc-item .label-tit {
  font-family: "NotoM";
  color: #222;
  font-size: 15px;
}
.desc-content .item.desc-left .desc-item {
  padding-left: 90px;
}
.desc-content .item.desc-left .desc-item .desc:after {
  clear: both;
  content: "";
  display: block;
}
.desc-content .item.desc-left .desc-item .desc .datepicker {
  float: left;
}
.desc-content .item.desc-left .desc-item .desc span.wave {
  float: left;
  padding: 0 6px;
}
.desc-content .item.desc-left .desc-item .td-s-thumb.search-area:after {
  clear: both;
  content: "";
  display: block;
}
.desc-content .item.desc-left .desc-item .td-s-thumb.search-area input,
.desc-content .item.desc-left .desc-item .td-s-thumb.search-area .ip-box {
  float: left;
}
.desc-content .item.desc-left .desc-item .desc.select select {
  width: 70%;
}
.desc-content .item.desc-left {
  width: 35%;
  padding-right: 40px;
}
.desc-content .item.desc-center {
  width: 35%;
  padding-right: 40px;
}
.desc-content .item.desc-right {
  width: 30%;
}
.search-area input {
  position: relative;
}
.search-area .icon {
  position: absolute;
  right: 8px;
  top: 1px;
  z-index: 100;
  cursor: pointer;
  font-size: 16px;
  color: #555;
}
.search-border .td-s-thumb {
  position: relative;
  display: inline-block;
}
.search-border .td-s-thumb.search-area > input,
.search-border
.td-s-thumb.search-area
> .ip-box
.search-border
.td-s-thumb.search-area
> button {
  float: left;
}
.search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
  width: 60%;
  margin-left: 6px;
}
.remove_text {
  margin-left: 0;
}
.contents div.gridbox_material.gridbox .xhdr {
  border-bottom: 1px solid #dfdfdf;
}

.btn-search {
  border-radius: 4px;
  padding: 0 20px;
  font-size: 15px;
  height: 34px;
  font-family: 'NotoM';
  background: #646464;
  color: #fff;
}

@media (max-width: 1580px) {
  .search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
    width: 50%;
  }
}
</style>